import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * Client-side routing (wouter) doesn't reset scroll position on navigation
 * the way a normal full page load does -- without this, clicking a link
 * (e.g. from the homepage footer to a blog post) leaves you scrolled to
 * wherever you were on the previous page, often landing on the footer
 * instead of the top of the new page. Mount once at the app root.
 */
export function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [location]);

  return null;
}
